import { auth, db, firebaseFunctions } from "./firebase";
import { collection, doc, setDoc } from "firebase/firestore";
import { ErrorWithDetails } from "../utility/error-handling/error-handling-utility";
import { ContactBookInvite, ContactBookInviteStatus, ContactRequest, Invite, InviteStatus, IsEmailRegisteredHttpRequestData } from "../types/dreico.types";
import { httpsCallable } from "firebase/functions";

interface CreateInviteVars {
    email: string;
    message?: string;
    request?: ContactRequest;
    userType?: 'connector' | 'user'
}

export const firebaseCreateInvite = async (vars: CreateInviteVars) => {
    /**
     * Create new invite
     */
    if (!auth.currentUser) {
        console.log('No user logged in')
        return
    }

    const { email, message, request, userType } = vars

    // Check if user already registered.
    const isEmailRegistered = httpsCallable(firebaseFunctions, 'isEmailRegistered')
    const isEmailRegisteredData: IsEmailRegisteredHttpRequestData = {
        email: vars.email
    }
    const isRegistered = await isEmailRegistered(isEmailRegisteredData);
    if (isRegistered.data === true) {
        return {
            success: false,
            error: false,
            message: `${vars.email} ist bereits registiert, Einladung nicht möglich.`
        }
    }

    // Get document reference for new document with auto-generated unique ID.
    const inviteDoc = isRegistered.data ? doc(collection(db, "contactBookInvites")) : doc(collection(db, "invites"))

    // Create document
    try {
        const invite: Invite = {
            inviter: auth.currentUser.uid,
            invitedMail: email,
            // use enum type
            status: InviteStatus.unused,
        }
        if (message != null && request != null) {
            invite.message = message;
            invite.requestId = request._id;
        }
        if (userType) {
            invite.userType = userType
        }

        await setDoc(inviteDoc, invite);
        return {
            success: true,
            error: false,
            message: `${email} wurde zu dreico eingeladen`,
        }
    } catch (e) {
        return {
            success: false,
            error: true,
            message: new ErrorWithDetails(e, 'einladen von ' + email),
        }
    }
}

interface CreateAddContactVars {
    email: string;
}

export const firebaseAddContact = async (vars: CreateAddContactVars) => {
    /**
     * Create new invite
     */
    if (!auth.currentUser) {
        console.log('No user logged in')
        return
    }

    const { email } = vars

    // Get document reference for new document with auto-generated unique ID.
    const contactBookInvitesDok = doc(collection(db, "contactBookInvites"))

    // Create document
    try {
        const contactBookInvite: ContactBookInvite = {
            addedById: auth.currentUser.uid,
            addedUserEmail: email,
            // use enum type
            status: ContactBookInviteStatus.unused,
        }

        await setDoc(contactBookInvitesDok, contactBookInvite);
        return {
            success: true,
            error: false,
            message: `${email} wurde zu Ihrem Kontaktbuch eingeladen.`,
        }
    } catch (e) {
        return {
            success: false,
            error: true,
            message: new ErrorWithDetails(e, 'einladen von ' + email),
        }
    }
}